export default {
  get: function() {
    return {
      fetching: null,
      uri: null,
      error: null
    }
  }
}
